import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from '../components/not-found/not-found.component';
import { SideNavComponent } from '../side-nav/side-nav.component';

const wRoute: Routes = [
  {
    path: '**',
    component: SideNavComponent,
    children: [{ path: '', component: NotFoundComponent, pathMatch: 'full' }],
  },
];

@NgModule({
  imports: [RouterModule.forChild(wRoute)],
  exports: [RouterModule],
})
export class WildcardRoutingModule {}
